/*
 * Questions the candidate marked "for review". Kept in this browser, one entry
 * per attempt, so a reload keeps them; they are the candidate's own aid and
 * are not sent to the server or graded. Storage can be blocked (private mode,
 * full quota): flags then still work, they just do not survive a reload.
 */
const storageKey = (attemptId: string) => `examing.exam-flags.${attemptId}`;

export function loadFlags(attemptId: string): string[] {
  try {
    const raw = localStorage.getItem(storageKey(attemptId));
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

export function saveFlags(attemptId: string, flagged: ReadonlySet<string>): void {
  try {
    if (flagged.size === 0) localStorage.removeItem(storageKey(attemptId));
    else localStorage.setItem(storageKey(attemptId), JSON.stringify([...flagged]));
  } catch {
    // The flags live on in memory.
  }
}

export function clearFlags(attemptId: string): void {
  try {
    localStorage.removeItem(storageKey(attemptId));
  } catch {
    // Nothing to clear.
  }
}
